import { useMemo } from 'react'
import {
  type SpreadGeometryInput,
  computeSpreadPageRects,
} from '@/lib/backgrounds/spread-page-rects'
import type { SpreadPageRects } from '@/lib/backgrounds/types/spread-page-rects'

/** `computeSpreadPageRects` for one spread, recomputed only when its geometry changes. */
export function useSpreadPageRects({
  bleedWidth,
  pageTrimWidth,
  trimHeight,
  bleedMargin,
  spreadOriginCanvasX,
  singlePageSide,
}: SpreadGeometryInput): SpreadPageRects {
  return useMemo(
    () =>
      computeSpreadPageRects({
        bleedWidth,
        pageTrimWidth,
        trimHeight,
        bleedMargin,
        spreadOriginCanvasX,
        singlePageSide,
      }),
    [bleedWidth, pageTrimWidth, trimHeight, bleedMargin, spreadOriginCanvasX, singlePageSide]
  )
}
